<template>
  <div>
    <role-promission
      subTitle="角色权限编辑"
      :roleApi="setmeal"
    ></role-promission>
  </div>
</template>

<script>
import rolePromission from '@/components/setting/rolePromission.vue'
import setmeal from '@/backend/services/account/setmeal.js'
export default {
  data() {
    return { setmeal }
  },
  methods: {},
  components: {
    rolePromission,
  },
}
</script>

<style>
</style>
